export default __webpack_public_path__ + "static/media/ReleaseNotes_Content_Status.380b8429.jpg";